export const styles = {
  root: {
    backgroundColor: 'var(--white)',
    borderRadius: '4px',
    //width: '100%',
    //height: '88px',
    width: '88px',
    height: '88px',
    overflow: 'hidden',
    position: 'relative',
    cursor: 'pointer',
    '& > img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'end',
  },
  pdfIcon: {
    position: 'relative',
    width: '88px',
    height: '88px',
    div: {
      display: 'none',
    },
    'a:hover + div': {
      display: 'block',
    },
  },
  title: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: '50%',
    backgroundColor: 'rgba(0,0,0,0.3)',
    pointerEvents: 'none',
    color: '#FFF',
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: '500',
    textWrap: 'wrap',
    wordWrap: 'break-word',
    //overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
  },
}
